import React from "react";
import Breadclumbs from "./Breadclumbs";

function ProdectDetels() {
  return (
    <main>
      <Breadclumbs />
    </main>
  );
}

export default ProdectDetels;
